<template>
  <div>
    <v-app id="app">
      <AppHeader />
      <AppHeader2 />
      <router-view :key="$route.fullPath" />
    </v-app>
    <AppFooter />
  </div>
</template>
<script>
import AppHeader from "./components/Common/appHeader";
import AppHeader2 from "./components/Common/appHeader2";
import AppFooter from "./components/Common/appFooter";
import store from "./store";

export default {
  components: {
    AppHeader,
    AppHeader2,
    AppFooter,
  },
  data() {
    return {};
  },
  beforeMount() {
    store.commit("changeCart", 0);
  },
};
</script>
<style>
@font-face {
  font-family: madesaonara2;
  src: url("./assets/fonts/madesaonara2.otf");
}
@font-face {
  font-family: robotoregular;
  src: url("./assets/fonts/robotoregular.ttf");
}
@font-face {
  font-family: robotomedium;
  src: url("./assets/fonts/robotomedium.ttf");
}
@font-face {
  font-family: poppinslight;
  src: url("./assets/fonts/poppinslight.ttf");
}
@font-face {
  font-family: poppinsregular;
  src: url("./assets/fonts/poppinsregular.ttf");
}
@font-face {
  font-family: poppinsmedium;
  src: url("./assets/fonts/poppinsmedium.ttf");
}
@font-face {
  font-family: poppinssemibold;
  src: url("./assets/fonts/poppinssemibold.ttf");
}
@font-face {
  font-family: poppinsbold;
  src: url("./assets/fonts/poppinsbold.ttf");
}
@font-face {
  font-family: poppinsextrabold;
  src: url("./assets/fonts/poppinsextrabold.ttf");
}
@font-face {
  font-family: opensanslight;
  src: url("./assets/fonts/opensanslight.ttf");
}
@font-face {
  font-family: opensansregular;
  src: url("./assets/fonts/opensansregular.ttf");
}
@font-face {
  font-family: opensanssemibold;
  src: url("./assets/fonts/opensanssemibold.ttf");
}
@font-face {
  font-family: opensansbold;
  src: url("./assets/fonts/opensansbold.ttf");
}
@font-face {
  font-family: opensansextrabold;
  src: url("./assets/fonts/opensansextrabold.ttf");
}
body {
  margin: 0px !important;
  padding: 0px !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.row {
  margin: 2px;
  /* margin-right: 0px !important;
  margin-left: 0px !important; */
}
a {
  text-decoration: none !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px !important;
  height: 10px !important;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey !important;
  border-radius: 5px !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  /* background: #919191 !important; */
  background: #63028f !important;
  border-radius: 5px !important;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border: 1px solid #d6d6d6;
  outline: 0;
  border-width: 1px 1px 1px;
  text-align: "center";
  padding-left: 12px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
